// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCiCYrfT04vAccd9U7w9RonPw0IxeQ9aVY",
    authDomain: "portfolio-backend-f7893.firebaseapp.com",
    projectId: "portfolio-backend-f7893",
    storageBucket: "portfolio-backend-f7893.appspot.com",
    messagingSenderId: "232744061239",
    appId: "1:232744061239:web:bfb64c85ddcb608558b2b2"
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Storage
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
